import type { JSX } from 'react'
import type { IControlsProps } from '../Controls'

import {
  InlineBackwardButton,
  InlineForwardButton,
} from 'atoms/Button/Templates'
import { ContainerControls } from '../Controls'

/**
 * Controls always visible
 * Control is disabled if there is no pagination step
 */

export type IInlineControlsTemplateProps = Omit<IControlsProps, 'children'>

export const InlineControlsTemplate = ({
  controlsState = [
    {
      visible: true,
      disabled: false,
    },
    {
      visible: true,
      disabled: false,
    },
  ],
  ...rest
}: IInlineControlsTemplateProps): JSX.Element => (
  <ContainerControls controlsState={controlsState} {...rest}>
    <InlineBackwardButton />
    <InlineForwardButton />
  </ContainerControls>
)
